// Ver Kontrol SIN INTERNET (parte 1: solo lectura).
// Cada vez que se LEE algo de la base (productos, clientes, ventas...) se
// guarda una copia en este dispositivo. Si luego no hay señal, se muestra esa
// copia. Lo que GUARDA o CAMBIA datos nunca usa copias: sin señal, falla.
const CACHE = 'kontrol-datos-v1';
const CLAVE_FECHA = 'kontrol-datos-fecha';

// Funciones de la base que solo leen (se pueden responder con la copia).
const LECTURAS_RPC = ['es_admin_kontrol', 'cupos_fundador', 'equipo_listar'];

const hayCache = () => typeof window !== 'undefined' && 'caches' in window;

let usandoCopia = false;
const avisar = () => window.dispatchEvent(new Event('kontrol-conexion'));

function marcarCopia(valor) {
  if (usandoCopia === valor) return;
  usandoCopia = valor;
  avisar();
}

export const estaUsandoCopia = () => usandoCopia;

export function fechaDeCopia() {
  try { const t = Number(localStorage.getItem(CLAVE_FECHA)); return t ? new Date(t) : null; } catch { return null; }
}

// La copia se guarda por dirección. Las RPC (POST) suman sus parámetros, y las
// lecturas de un solo registro (.single) se distinguen de las de lista.
function claveDe(url, metodo, init) {
  const h = init.headers instanceof Headers
    ? init.headers.get('accept')
    : (init.headers || {}).Accept || (init.headers || {}).accept;
  const extra = [];
  if (metodo === 'POST') extra.push(`_p=${encodeURIComponent(typeof init.body === 'string' ? init.body : '')}`);
  if (String(h || '').includes('vnd.pgrst.object')) extra.push('_uno=1');
  return extra.length ? `${url}${url.includes('?') ? '&' : '?'}${extra.join('&')}` : url;
}

export async function fetchConRespaldo(input, init = {}) {
  const url = typeof input === 'string' ? input : input.url;
  const metodo = String(init.method || (typeof input === 'string' ? 'GET' : input.method) || 'GET').toUpperCase();
  const rpc = (url.match(/\/rest\/v1\/rpc\/([a-z_]+)/) || [])[1];
  const esLectura = url.includes('/rest/v1/')
    && (rpc ? metodo === 'POST' && LECTURAS_RPC.includes(rpc) : metodo === 'GET');
  if (!esLectura || !hayCache()) return fetch(input, init);

  const clave = claveDe(url, metodo, init);
  try {
    const r = await fetch(input, init);
    // Solo se guarda lo leído con sesión (si la sesión no se pudo renovar, la
    // respuesta viene vacía y no debe reemplazar la copia buena).
    const auth = init.headers instanceof Headers ? init.headers.get('authorization') : (init.headers || {}).Authorization;
    const conSesion = String(auth || '').split('.').length === 3;
    if (r.ok && conSesion) {
      const copia = r.clone();
      caches.open(CACHE).then((c) => c.put(new Request(clave), copia)).catch(() => {});
      try { localStorage.setItem(CLAVE_FECHA, String(Date.now())); } catch { /* sin almacenamiento */ }
      marcarCopia(false);
    }
    return r;
  } catch (err) {
    const c = await caches.open(CACHE).catch(() => null);
    const guardada = c && (await c.match(new Request(clave)));
    if (guardada) { marcarCopia(true); return guardada; }
    throw err;
  }
}

// Al cerrar sesión se borra la copia (otra persona puede usar el dispositivo).
export async function borrarCopiaLocal() {
  usandoCopia = false;
  try { localStorage.removeItem(CLAVE_FECHA); } catch { /* sin almacenamiento */ }
  if (hayCache()) await caches.delete(CACHE).catch(() => {});
}
